/**
 * Merge two arrays by `id`, keeping existing items and appending
 * incoming items whose id is not already present.
 */
export function mergeById<T extends { id: string }>(
  existing: T[],
  incoming: T[],
): T[] {
  const seen = new Set(existing.map((item) => item.id));
  return [...existing, ...incoming.filter((item) => !seen.has(item.id))];
}
